var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.groups.length > 0
      ? _c(
          "ul",
          _vm._l(_vm.groups, function (group) {
            return _c(
              "li",
              { key: group.slug, staticClass: "block" },
              [
                _c("admin-post-group-by-post", {
                  attrs: {
                    group: group,
                    "post-id": _vm.postId,
                    "initial-post-ids":
                      group.postIds == null ? [] : group.postIds,
                  },
                }),
              ],
              1
            )
          }),
          0
        )
      : _vm.isLoading === false
      ? _c("div", [_c("p", [_vm._v(_vm._s(_vm.$t('msg["Data is empty"]')))])])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }